import type { AutoshipCustomerApiResponse } from '@libs/common-types';
import { logger } from '@libs/core';

import { cweaClient } from '../clients/api-proxy-browser-client';
import { CWEA_ENDPOINTS } from '../constants';

export async function getCustomerAutoshipSubscriptions(): Promise<AutoshipCustomerApiResponse> {
    const url = CWEA_ENDPOINTS.autoship.getCustomerSubscriptions();

    const result = await cweaClient.get<AutoshipCustomerApiResponse>(url, {
        useOldFetch: true,
    });

    if (!result?.data) {
        const err = new Error(`[GET CUSTOMER AUTOSHIP SUBSCRIPTIONS]: ${url} returned null`);
        logger.error(`[GET CUSTOMER AUTOSHIP SUBSCRIPTIONS][Error]`, err);
        throw err;
    }

    return result;
}
